module.exports = __webpack_public_path__ + "static/media/aws.32edd489.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/icons/aws.png
// module id = 69
// module chunks = 0